/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustLocationDetailResVo } from './AdminStockAdjustLocationDetailResVo';
import {
    AdminStockAdjustLocationDetailResVoFromJSON,
    AdminStockAdjustLocationDetailResVoFromJSONTyped,
    AdminStockAdjustLocationDetailResVoToJSON,
    AdminStockAdjustLocationDetailResVoToJSONTyped,
} from './AdminStockAdjustLocationDetailResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockAdjustLocationDetailResVo
 */
export interface ResponseAdminStockAdjustLocationDetailResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockAdjustLocationDetailResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockAdjustLocationDetailResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockAdjustLocationDetailResVo}
     * @memberof ResponseAdminStockAdjustLocationDetailResVo
     */
    data?: AdminStockAdjustLocationDetailResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockAdjustLocationDetailResVo interface.
 */
export function instanceOfResponseAdminStockAdjustLocationDetailResVo(value: object): value is ResponseAdminStockAdjustLocationDetailResVo {
    return true;
}

export function ResponseAdminStockAdjustLocationDetailResVoFromJSON(json: any): ResponseAdminStockAdjustLocationDetailResVo {
    return ResponseAdminStockAdjustLocationDetailResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationDetailResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockAdjustLocationDetailResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockAdjustLocationDetailResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockAdjustLocationDetailResVoToJSON(json: any): ResponseAdminStockAdjustLocationDetailResVo {
    return ResponseAdminStockAdjustLocationDetailResVoToJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationDetailResVoToJSONTyped(value?: ResponseAdminStockAdjustLocationDetailResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockAdjustLocationDetailResVoToJSON(value['data']),
    };
}

